export default __webpack_public_path__ + "static/media/maps.3d7218f0.svg";